import { useAtomValue } from 'jotai';
import { useTranslation } from 'next-i18next';

import { Title } from '@restworld/ui-ds';

import { workerPastExperiencesAtom } from '../../../../employer-job-listing.atoms';
import { TabCardWrapper } from '../candidate-profile-section';
import { WorkerExperienceItem } from './worker-experience-item';
import { StyledSeparator } from './worker-experience';

export const WorkerExperiencesSection = () => {
  const workerPastExperiences = useAtomValue(workerPastExperiencesAtom);
  const itemsCount = workerPastExperiences?.length || 0;
  const { t } = useTranslation('onboarding-page');
  const errorMessage = t('missing_info');

  return (
    <TabCardWrapper title={t('experiences')}>
      {workerPastExperiences?.map((workerPastExperience, index) => (
        <div tw="w-full" key={index} id={`work_experience-${index}`}>
          <WorkerExperienceItem workerPastExperience={workerPastExperience} key={index} experienceIndex={index} />
          {index < itemsCount - 1 && <StyledSeparator />}
        </div>
      ))}
      {!workerPastExperiences?.length && (
        <Title fontWeight="normal" textColor="gray-500" variant="h6-large">
          {errorMessage}
        </Title>
      )}
    </TabCardWrapper>
  );
};
